/* eslint-disable import/prefer-default-export */
import { NOTIFICATION_TYPE } from 'components/v2/notification/notification';

const SHOP_SAVE_SETTINGS_ERROR = {
  id: 'SHOP_SAVE_SETTINGS_ERROR',
  type: NOTIFICATION_TYPE.WARNING,
  message: 'An error occurred during saving',
  description: '',
};

export const makeErrorMessage = (description = '') => ({
  ...SHOP_SAVE_SETTINGS_ERROR,
  description,
});
